export default __webpack_public_path__ + "static/media/Android_phone_sandia_100dpi.81b665eb.png";